import {
  MODULE_PATH_INDEX,
  BUCKET_PATH_INDEX,
  MENU_SCREEN_BY_BUCKET_NAME,
} from '@app/constants';
import { getPathWithOrgData } from './navigation';

export const getModulePath = (path?: string) => {
  const pathSplitted = (path || location.pathname).split('/');
  return pathSplitted[MODULE_PATH_INDEX];
};

export const getBucketPath = (path?: string) => {
  const pathSplitted = (path || location.pathname).split('/');
  return pathSplitted[BUCKET_PATH_INDEX];
};

export const isMenuPath = (path: string) => getModulePath(path) === 'menu';
export const isSettingsPath = (path: string) =>
  getModulePath(path) === 'settings';
export const isReportsPath = (path: string) =>
  getModulePath(path) === 'reports';
export const isCustomersPath = (path: string) =>
  getModulePath(path) === 'customers';
export const isFreshSheetPath = () =>
  location.pathname.includes(getPathWithOrgData('/menu/fresh-sheet'));

export const isTableLayoutPath = () =>
  location.pathname.includes(getPathWithOrgData('/settings/table-layout'));

export const isOtherPath = (path: string) =>
  !isMenuPath(path) && !isSettingsPath(path);

export const isItemsPath = (path: string) => getBucketPath(path) === 'items';

export const isItemsScreenPath = (path: string) => {
  const pathSplitted = path.split('/');
  const noExtraPath = !pathSplitted[BUCKET_PATH_INDEX + 1];

  return isItemsPath(path) && noExtraPath;
};

export const getBucketIdFromPath = (
  path: string,
):
  | Exclude<keyof typeof MENU_SCREEN_BY_BUCKET_NAME, 'hotButtons'>
  | undefined => {
  const segmentedPath = path.split('/');

  const joinedPath =
    '/' + segmentedPath.slice(3, segmentedPath.length - 1).join('/');
  const lastSegment = segmentedPath[segmentedPath.length - 1];

  const isValidEnding = /^\d+$/.test(lastSegment) || lastSegment === 'add';
  if (!isValidEnding) return undefined;

  for (const [key, validPath] of Object.entries(MENU_SCREEN_BY_BUCKET_NAME)) {
    if (key === 'hotButtons') continue;
    if (joinedPath === validPath) {
      return key as Exclude<
        keyof typeof MENU_SCREEN_BY_BUCKET_NAME,
        'hotButtons'
      >;
    }
  }

  return undefined;
};

export const generatePathKey = () => {
  const _tabKey = Math.random().toString(36).substr(2, 9);
  return _tabKey;
};
